import React, { useMemo, useRef } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import {
  Column,
  Sorting,
  HeaderFilter,
  StateStoring,
  Paging
} from 'devextreme-react/data-grid';
import DataGrid from 'components/devExtreme/DataGrid';
import columnSchema from 'components/underwrite/acquisition/propertyUnderwrite/header/viewCrmTabs/viewCrmHistorySchema';
import { dataGridExtension } from 'components/devExtreme';
import { parseISO, format } from 'date-fns';
import ViewOpportunityHistoryDetailsModal from 'components/underwrite/acquisition/propertyUnderwrite/header/ViewOpportunityHistoryDetailsModal';
import {
  fetchOpportunityHistoryTableDetails,
  setEventSummaryRowData,
} from 'store/actions';

const ViewCrmHistory = ({ classes, crmInfo, setEventSummaryRowData, fetchOpportunityHistoryTableDetails, txnOppId }) => {
  const grid = useRef(null);

  const onSetGridRef = g => {
    grid.current = g;
  }

  let dataSource = useMemo(() => {
    if (crmInfo) {
      const withParsedDates = crmInfo.map(history => {
        const parsedDates = {};
        if (history.eventDate) parsedDates.eventDate = format(parseISO(history.eventDate), 'MM/dd/yyyy, h:mm:ss a');
        return {
          ...history,
          ...parsedDates
        }
      })
      return withParsedDates;
    }
    return null;
  }, [crmInfo]);

  const getCellRender = (cell) => {
    if (!crmInfo || cell.value === null || cell.value === undefined) {
      return null
    }

    switch (cell.column.dataField) {
      case 'eventDate':
        return format(cell.value, 'MM/dd/yyyy, h:mm:ss a');
      default:
        return null;
    }
  }
  const handleRowDoubleClick = row => {
    if (row.data.eventType === 'Receipt') {
      setEventSummaryRowData({eventType: 'CrmReceipts', eventDate: row.data.createdOn, tableId: row.data.id });
      fetchOpportunityHistoryTableDetails({ txnOppId: txnOppId, eventSummary: { ...row.data, detailsTypeDisplay: 'CrmReceipts' }});
    }
    if (row.data.eventType === 'Submission') {
      setEventSummaryRowData({eventType: 'CrmSubmissions', eventDate: row.data.createdOn, tableId: row.data.id });
      fetchOpportunityHistoryTableDetails({ txnOppId: txnOppId, eventSummary: { ...row.data, detailsTypeDisplay: 'CrmSubmissions' }});
    }
  }
  
  let columns = useMemo(() => {
    return columnSchema.map(({ field, displayName, width, type, format, visible, sortIndex, sortOrder, headerFilter }) => {
      let cellRender = null;
      if (['eventDate'].includes(field)) {
        cellRender = getCellRender;
      }
      return (
        <Column
          key={field}
          dataField={field}
          caption={displayName}
          width={width}
          dataType={type}
          format={format}
          allowSorting={true}
          allowGrouping={true}
          visible={visible !== false}
          sortIndex={sortIndex}
          sortOrder={sortOrder}
          cellRender={cellRender}
        >
          <HeaderFilter dataSource={(options) => dataGridExtension.headerFilterSort(options, dataSource, field, type, headerFilter)} />
        </Column>
      )
    })
  }, [dataSource]);
  return (
    <>
      <DataGrid
        ref={onSetGridRef}
        dataSource={dataSource}
        keyExpr='eventDate'
        allowColumnReordering={true}
        allowColumnResizing={true}
        columnResizingMode='widget'
        showBorders={true}
        showRowLines={true}
        showColumnLines={true}
        height={550}
        width={'100%'}
        hoverStateEnabled={true}
        onRowDblClick={handleRowDoubleClick}
        columnAutoWidth={true}
        focusedRowEnabled={true}
        enableTooltips
        tooltips={columnSchema}
      >
        <HeaderFilter visible={true} search={{ enabled: true }} hideSelectAllOnSearch={false} />
        <Sorting mode={'multiple'} />
        <Paging enabled={false} />
        <StateStoring
          enabled={false}
          type={'custom'}
          storageKey={'storage'}
          customSave={state => console.log(state)}
        />
        {columns}
      </DataGrid>
      {/* Re-use OpportunityHistory Modal to show CrmReceipts table */}
      <ViewOpportunityHistoryDetailsModal /> 
    </>
  )
}

const styles = theme => ({
  dialog: {
    minWidth: '200px',
    minHeight: '150px'
  },
  textFieldRoot: {
    height: 70,
    marginBottom: 16,
    paddingRight: 8,
    flexBasis: '25%'
  },
  errorText: {
    lineHeight: 1
  },
  textWrapper: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  textLabel: {
    minWidth: '200px'
  },
  divider: {
    marginTop: '4px',
    marginBottom: '4px'
  }
});

const mapState = state => ({});
const mapDispatch = dispatch => ({
  fetchOpportunityHistoryTableDetails: (payload) => dispatch(fetchOpportunityHistoryTableDetails(payload)),
  setEventSummaryRowData: importRecord => dispatch(setEventSummaryRowData(importRecord)),
});

export default compose(
  withStyles(styles),
  connect(mapState, mapDispatch)
)(ViewCrmHistory);